import React, { useRef } from 'react'
import { Result, Subtask } from 'constants/interfaces'
import { Button } from 'components/ui'
import { FileCards } from 'components/UploadedFileList/FileCards'
import { useExecutionFiles } from '../../hooks/useExecutionFiles'
import { useWorkspaceText } from '../../hooks/useWorkspaceText'
import styles from './styles.module.css'

export function ExecutionFileAnswer({
  subtask,
  result,
  disabled,
}: {
  subtask: Subtask
  result?: Result
  disabled: boolean
}) {
  const t = useWorkspaceText()
  const input = useRef<HTMLInputElement>(null)
  const upload = useExecutionFiles(subtask, result)
  return (
    <div className={styles.files}>
      <FileCards files={result?.files || []} />
      <Button variant="secondary" isDisabled={disabled || upload.busy} onClick={() => input.current?.click()}>
        {t.upload}
      </Button>
      <input
        type="file"
        aria-label={t.upload}
        multiple
        hidden
        ref={input}
        disabled={disabled}
        onChange={(event) => {
          upload.add(Array.from(event.target.files || []))
          event.target.value = ''
        }}
      />
      {upload.busy && <p role="status">{t.saving}</p>}
      {!upload.busy && !!upload.queue.length && (
        <div role="alert">
          {t.saveError}
          <Button isDisabled={disabled} onClick={upload.retry}>
            {t.retry}
          </Button>
        </div>
      )}
    </div>
  )
}
